import { StyleSheet } from 'aphrodite';
import { DefaultBorder } from '../../styles/styles';
import { THEME } from '../Theme/theme';

const { spacing, colors, common } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		position: 'relative',
		width: 154,
	},
	colorBox: {
		width: '100%',
		height: 42,
		borderRadius: common.borderRadius,
		border: DefaultBorder,
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	hexOverlay: {
		fontSize: 14,
		fontWeight: 600,
		textAlign: 'center',
		color: colors.text.dark,
		userSelect: 'none',
	},
	hexOverlayWhite: {
		color: colors.background.light,
	},
	popoverContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
	},
	popover: {
		position: 'absolute',
		top: 'calc(100% + 8px)',
		left: 0,
		zIndex: 1000,
		background: colors.background.light,
		border: DefaultBorder,
		borderRadius: common.borderRadius,
		padding: spacing.sm,
		boxShadow: `0 4px 12px 0 ${colors.border.light}`,
	},
	inputLabel: {
		fontSize: 14,
		color: colors.text.light,
		marginBottom: spacing.xs,
		marginRight: spacing.sm,
	},
	hexInput: {
		width: 100,
		height: 32,
		fontSize: 14,
		color: colors.text.dark,
		background: colors.background.light,
		border: DefaultBorder,
		borderRadius: common.borderRadius,
		padding: `${spacing.xs}px ${spacing.sm}px`,
		outline: 'none',
		':focus': {
			borderColor: colors.primary.main,
		},
	},
});
